import axios from "../../axios-atis";

import * as actionTypes from "./actionTypes";

export const fetchCompaniesBegin = () => ({
  type: actionTypes.FETCH_COMPANIES_BEGIN
});

export const fetchCompaniesSuccess = companies => {
  return {
    type: actionTypes.FETCH_COMPANIES_SUCCESS,
    payload: { companies }
  };
};

export const fetchCompaniesError = error => {
  return {
    type: actionTypes.FETCH_COMPANIES_FAILED,
    payload: { error }
  };
};
export const fetchCompanies = () => {
  return dispatch => {
    dispatch(fetchCompaniesBegin());

    let url = "/companies";
    axios
      .get(url)
      .then(response => {
        dispatch(fetchCompaniesSuccess(response.data));
      })
      .catch(err => {
        dispatch(fetchCompaniesError(err));
      });
  };
};

export const addCompanyBegin = () => {
  return {
    type: actionTypes.ADD_COMPANY_BEGIN
  };
};

export const addCompanySuccess = company => {
  return {
    type: actionTypes.ADD_COMPANY_SUCCESS,
    payload: { company }
  };
};

export const addCompanyError = error => {
  return {
    type: actionTypes.ADD_COMPANY_FAILED,
    payload: { error }
  };
};
export const addCompany = newCompany => {
  return dispatch => {
    dispatch(addCompanyBegin());
    let url = "/companies";
    axios
      .post(url, newCompany)
      .then(response => {
        //console.log(response);
        if (null == response.data.result || response.data.status !== 201) {
          dispatch(addCompanyError(response.data));
        } else {
          dispatch(addCompanySuccess(response.data.result));
        }
      })
      .catch(err => {
        dispatch(addCompanyError(err));
      });
  };
};

export const updtCompanyBegin = () => {
  return {
    type: actionTypes.UPDATE_COMPANY_BEGIN
  };
};

export const updtCompanySuccess = company => {
  return {
    type: actionTypes.UPDATE_COMPANY_SUCCESS,
    payload: { company }
  };
};

export const updtCompanyError = error => {
  return {
    type: actionTypes.UPDATE_COMPANY_FAILED,
    payload: { error }
  };
};
export const updtCompany = company => {
  return dispatch => {
    dispatch(updtCompanyBegin());
    let url = "/companies/" + company.id;
    axios
      .post(url, company)
      .then(response => {
        if (undefined === response || undefined === response.data) {
          dispatch(updtCompanyError(null));
        } else {
          dispatch(updtCompanySuccess(response.data.result));
        }
      })
      .catch(err => {
        dispatch(updtCompanyError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/company.js